import React, { useState } from "react";



const ContactForm = () => {
  const [from, setFrom] = useState("");
  const [text, setText] = useState("");
  const [sent, setSent] = useState(false);

  const handleContact = (e) => {
    e.preventDefault();
    const blog = { from, text };
    fetch(`${process.env.REACT_APP_BASE_URL}/contact-us`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify(blog),
    })
      .then((res) => res.json())
      .then((data) => {
        setSent(true);
        setText("");
        setFrom("");
      })
      .catch((err) => {
        alert(err);
      });
  };

  return (
    <div className="contactForm">
      <div className="row">
        <div className="col-12">
          <a href="/">
            <img src="BlueLogo.svg" alt="logo" />
          </a>
        </div>
      </div>

      <div className="row">
        <div className="col-12">
          <h1>Contact information</h1>

          <a href="https://wa.me/+201022251989" style={{ textDecoration: "none" }} target="_blank">
            <p>
              <span style={{ fontSize : "34px"}}>
                <i className="fa-brands fa-whatsapp" style={{color : "green"}}></i>
              </span>
              +201022251989
            </p>
          </a>
          <a href="mailto: elsherbiny44@hotmail.com" style={{ textDecoration: "none" }} target="_blank">

            <p>
              <span>
                <img src="/email.svg" alt="email" />
              </span>
              elsherbiny44@hotmail.com
            </p>
          </a>
          <p>
            <span>
              <img src="/location.svg" alt="location" />
            </span>
            Mansoura_Gehan Street
          </p>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <h1>Send Message</h1>
          <form onSubmit={handleContact}>
            <div className="mb-3">
              <label htmlFor="exampleFormControlInput1" className="form-label">
                Email Address
              </label>
              <input
                type="email"
                className="form-control"
                id="exampleFormControlInput1"
                onChange={(e) => setFrom(e.target.value)}
              />
            </div>
            <div className="mb-3">
              <label
                htmlFor="exampleFormControlTextarea1"
                className="form-label"
              >
                Message{" "}
              </label>
              <textarea
                className="form-control"
                id="exampleFormControlTextarea1"
                rows="5"
                onChange={(e) => setText(e.target.value)}
              />
            </div>
            {sent && (
              <div className="success">
                <span>
                  Sent successfully ! and we will contact you as soon as
                  possible
                </span>
              </div>
            )}
            <button className="btn contBut">Send</button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ContactForm;
